import {Component, OnInit} from '@angular/core';
import {SuggestionListsService} from '../../../services/suggestion-lists.service';
import {ComponentBackgroundService} from '../../../../../../services/component-background.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../../../../services/user.service';
import {AdminService} from '../../../../../../services/admin.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-my-drafts-tab',
  templateUrl: './my-drafts-tab.component.html',
  styleUrls: ['./my-drafts-tab.component.css']
})
export class MyDraftsTabComponent implements OnInit {
  isLoaded = false;
  myDraftsList: any[] = [];
  internalServerError = false;
  thisUser: any;

  constructor(public suggestionListsService: SuggestionListsService,
              public componentBackgroundService: ComponentBackgroundService,
              private userService: UserService,
              private adminService: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal, ) {
  }

  ngOnInit() {
    this.isLoaded = false;
    this.internalServerError = false;

    this.userService.getSelf().subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.thisUser = res.body;

          this.suggestionListsService.getDraftsByUserID(this.thisUser.id).subscribe(
            (response: any) => {
              if (response.status === 200) {
                this.myDraftsList = response.body;

                this.myDraftsList.forEach(draft => {
                  if (!draft.hasOwnProperty('template')) {
                    draft.template = '';
                  }
                });
                this.isLoaded = true;
              } else {
                // Error message
                this.internalServerError = true;
                this.isLoaded = true;
              }
            },
            () => {
              this.internalServerError = true;
              this.isLoaded = true;
            }
          );

        } else {
          this.internalServerError = true;
          this.isLoaded = true;
        }
      },
      () => {
        this.internalServerError = true;
        this.isLoaded = true;
      }
    );
  }

  openDraftDetails(draft) {
    this.suggestionListsService.setListType('edit');
    this.suggestionListsService.setDraft(draft);
    this.router.navigate(['/dashboard/create-suggestion-list']);
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/suggestion-lists/components/my-suggestion-lists/my-drafts-tab/my-drafts-tab.component.ts